import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '../../../../../i18n/constants/keys';
import type { JobPostingData } from '../../../../../utils/types/JobOpenings';
import type { IJobInfoItem } from '../../interfaces';
import { getJobKeyInfo } from '../functions';

/**
 * Translated key-info cards for the job header.
 * Pure derivation from post data + formatters; the view only renders the result.
 */
export const useJobKeyInfo = (
  jobPostData: JobPostingData | undefined,
  calculateDaysLeft: () => string,
  formatUnixTimestamp: (timestamp: number | string) => string,
): IJobInfoItem[] => {
  const { t } = useTranslation(NS.jobPortal);

  return useMemo(
    () =>
      getJobKeyInfo(
        t,
        jobPostData,
        calculateDaysLeft(),
        formatUnixTimestamp(jobPostData?.startDate ?? 0),
        formatUnixTimestamp(jobPostData?.endDate ?? 0),
      ),
    [t, jobPostData, calculateDaysLeft, formatUnixTimestamp],
  );
};
